var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecknumNofill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.316 18V16.512C8.99867 15.9467 9.66 15.3867 10.3 14.832C10.9507 14.2773 11.5267 13.728 12.028 13.184C12.54 12.64 12.9453 12.112 13.244 11.6C13.5533 11.0773 13.708 10.5707 13.708 10.08C13.708 9.62133 13.58 9.216 13.324 8.864C13.0787 8.512 12.668 8.336 12.092 8.336C11.5053 8.336 11.0627 8.528 10.764 8.912C10.4653 9.296 10.316 9.76 10.316 10.304H8.332C8.35333 9.48267 8.53467 8.8 8.876 8.256C9.21733 7.70133 9.67067 7.29067 10.236 7.024C10.8013 6.74667 11.436 6.608 12.14 6.608C13.2813 6.608 14.1667 6.92267 14.796 7.552C15.436 8.17067 15.756 8.976 15.756 9.968C15.756 10.5867 15.612 11.1893 15.324 11.776C15.0467 12.3627 14.6787 12.928 14.22 13.472C13.7613 14.016 13.2653 14.528 12.732 15.008C12.1987 15.4773 11.6813 15.9147 11.18 16.32H16.028V18H8.316Z",
    fill: "#366EE3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#366EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecknumNofill);
export default __webpack_public_path__ + "static/media/checknum-no fill.3281a94b4cddfb2d34676a5a78f8f56e.svg";
export { ForwardRef as ReactComponent };